var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMarketplace = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emfp8oAgJLM1",
    viewBox: "0 0 500 500",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.672098 0 0 1.6003-168.026049-138.009542)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.629555 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.908769,161.487245v27.17344q-2.781849,27.031923,27.031923,27.031923t27.854391-27.85439v-26.350975l-54.886314.000002Z",
    transform: "translate(5.374481 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.908769,161.487245v27.17344q-2.781849,27.031923,27.031923,27.031923t27.854391-27.85439v-26.350975l-54.886314.000002Z",
    transform: "translate(62.07679 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.908769,161.487245v27.17344q-2.781849,27.031923,27.031923,27.031923t27.854391-27.85439v-26.350975l-54.886314.000002Z",
    transform: "translate(119.07679 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.908769,161.487245v27.17344q-2.781849,27.031923,27.031923,27.031923t27.854391-27.85439v-26.350975l-54.886314.000002Z",
    transform: "translate(176.07679 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.908769,161.487245v27.17344q-2.781849,27.031923,27.031923,27.031923t27.854391-27.85439v-26.350975l-54.886314.000002Z",
    transform: "translate(233.07679 0.000002)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 10,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.382309,161.487245l27.264728-66.053497h228l27.972264,66.053497h-283.236992Z",
    transform: "translate(0 0.000004)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.000805,215.69261v173.794635l228-.000001-.353768-173.794635",
    transform: "translate(0 0.000001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.475348,389.487245v-139.487242h88.679282v139.487245-139.487245l-88.679282-.000001v139.487245-69.743622",
    fill: "none",
    stroke: "#000",
    strokeWidth: 10,
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMarketplace, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/marketplace.ff1458bd.svg";
export { ForwardRef as ReactComponent };